export const FormCardLang = {
    answersCount: 'پاسخنامه',
    notLoaded: 'عدم بارگزاری پاسخ نامه ها',
    lastActivity: 'آخرين زمان فعاليت',
    new: 'جدید',
    refreshErr: 'به روز رسانی اطلاعات انتشار با خطا مواجه شد. لطفا از اتصال خود به اینترنت اطمینان حاصل کنید',
};
